import { actionTypes } from 'actions/actionTypes'
import { feLoggingLogEvent, logLevels } from 'actions/log'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const clearGoustoRef: CheckoutActionCreator = () => async (dispatch) => {
  dispatch({
    type: actionTypes.CHECKOUT_SET_GOUSTO_REF,
    goustoRef: null,
  })
  dispatch(feLoggingLogEvent(logLevels.info, 'clearGoustoRef'))
}
